import {
  styled,
  ButtonBase,
  Box,
  IconButton,
  useTheme,
  PaletteMode,
} from "@mui/material";
import { Iconify } from "../icon/Iconify";

const RootStyle = styled(Box)(({ theme }) => ({
  background: theme.palette.grey[300],
  display: "flex",
  borderRadius: "6.25rem",
  padding: theme.spacing(0.3),
  gap: 0.3,

  [theme.breakpoints.down("md")]: {
    height: "1.4rem",
  },
}));
const SwitchButton = styled(IconButton, {
  shouldForwardProp: (props) => props !== "isActive",
})<{ isActive: boolean }>(({ theme, isActive }) => ({
  background: isActive ? theme.palette.primary.main : "",
  color: isActive ? "white" : theme.palette.grey[200],
  width: "1.6rem",
  height: "1.6rem",
  padding: 0,
  "&:hover": {
    background: isActive ? theme.palette.primary.main : "",
    color: isActive ? "white" : theme.palette.grey[200],
  },
  [theme.breakpoints.down("md")]: {
    width: "1.2rem",
    height: "1.2rem",
  },
}));
interface DarkModeSwitchProps {
  onChange: (mode: PaletteMode) => void;
}

export const DarkModeSwitch = ({ onChange }: DarkModeSwitchProps) => {
  const theme = useTheme();
  const mode = theme.palette.mode;
  return (
    <RootStyle>
      <SwitchButton
        isActive={mode === "light"}
        onClick={() => onChange("light")}
      >
        <Iconify icon="tabler:sun" fontSize="0.8rem" />
      </SwitchButton>
      <SwitchButton isActive={mode === "dark"} onClick={() => onChange("dark")}>
        <Iconify icon="octicon:moon-16" fontSize="0.8rem" />
      </SwitchButton>
    </RootStyle>
  );
};
